// 语言包索引文件
import zhCN from './zh-CN'
import enUS from './en-US'

export const messages = {
  'zh-CN': zhCN,
  'en-US': enUS,
}

export const localeNames = {
  'zh-CN': '简体中文',
  'en-US': 'English',
}

export const localeOptions = [
  { value: 'zh-CN', title: '简体中文', icon: '🇨🇳' },
  { value: 'en-US', title: 'English', icon: '🇺🇸' },
]

export default messages
